export enum StatusSchedulingEnum
{
    Liberadopendente = 1,
    aAprazar = 2,
    aprazado = 3,
    concluido = 4,
    Atrasado = 5,
    Suspenso = 6,
}